<template>
  <div class="imdiv" v-on:click="goArtistPortfolio" v-on:mouseenter="loadRollovers">
    <div class="square-filler">
      <ix-router-link :to="'/artists/' + artist.portfolio_url">
      <transition name="fade"><img v-if="seen"
      :src="getImageUrl(artist)" :alt="artist.formatted_name" class="main" /></transition></ix-router-link>
    </div>
    <slide-show :slides="rollovers" />
    
    <grey-bar :artist="artist" :likeImageId="artist.az_image.image_id" />
  </div>
</template>

<script>
import apix from '@/api.js'
import SlideShow from '@/components/widgets/SlideShow.vue'
import GreyBar from '@/components/widgets/GreyBar.vue'
import ViewablePanel from '@/mixins/ViewablePanel.js'

export default {
  components: {
    SlideShow,
    GreyBar
  },
  mixins: [ ViewablePanel ],
  props: {
    artist: Object,
    pageSettings: String
  },
  data: function () {
    return {
      rollovers: []
    }
  },
  
  methods: {
    goArtistPortfolio: function () {
      this.$ixr.push('/artists/' + this.artist.portfolio_url)
    },
    loadRollovers: async function () {
      if(this.rollovers.length < 1) {
        let res = this.$store.state.azimages[this.artist.artist_id]
        if(res) {
          this.rollovers = res
        }
        else {
          try {
            res = await apix.post('collections/azimages', { artist_id: Number(this.artist.artist_id) })
            this.$store.commit('setAzImages', { id: this.artist.artist_id, data: res.data })
            this.rollovers = res.data.filter(el => el.url != this.artist.az_image.url)
          }
          catch(err) {
            console.log(err)
          }
        }
      }
    },
    getImageUrl: function() {
      return this.$k.getImageCrop320(this.artist.az_image.url)
    }
  },
  watch: {
    pageSettings () {
      this.setInView()
    }
  }
}
</script>

<style scoped>
img.main{
  position:absolute;
  top:50%;
  left:50%;
  width:100%;
  transform:translate(-50%,-50%);
  transition:all 0.3s ease;
}
.square-filler{
  position:relative;
  overflow:hidden;
}
.imdiv:hover img.main{
  width:107%;
}

</style>
